import Vue from "vue";
import VueRouter from "vue-router";

// Guard
import { defaultGuard } from "@/middlewares/guards";

// Pages
import Login from "@/pages/Login";
import SetPassword from "@/pages/SetPassword";
import AppIntro from "@/pages/AppIntro";

//layouts
import PublicLayout from "@/layouts/PublicLayout.vue";

//Module routes
import territoryRoutes from "@/router/territory.routes";

Vue.use(VueRouter);

const routes = [
  {
    path: "/login",
    component: PublicLayout,
    beforeEnter: defaultGuard,
    children: [
      {
        path: "",
        name: "Login",
        component: Login,
        meta: {
          title: "Inicio de sesión",
        },
      },
    ],
  },
  {
    beforeEnter: defaultGuard,
    component: PublicLayout,
    path: "/set-password",
    children: [
      {
        path: "",
        name: "setPassword",
        component: SetPassword,
        meta: {
          title: "Recuperar contraseña",
        },
      },
    ],
  },
  {
    path: "/",
    redirect: "/seller-list/client/",
  },
  // {
  //   path: "/AppIntro",
  //   component: AppIntro,
  //   name: "AppIntro",
  // },
  ...territoryRoutes,
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
